import React from "react";

export default function SpinnerComponent() {
  return (
    <div
      style={{
        height: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 12,
      }}
    >
      <span
        style={{
          width: 36,
          height: 36,
          border: "3px solid #e2e8f0",
          borderTopColor: "#1d6cad",
          borderRadius: "50%",
          animation: "ds-spin 0.6s linear infinite",
          display: "inline-block",
        }}
      />
      <span style={{ color: "#94a3b8", fontSize: "0.875rem" }}>Загрузка...</span>
    </div>
  );
}